/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dispatch, SetStateAction, useState } from "react";
import { Box, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { Category } from "../../types/General";
import moment from "moment";
import usePermission from "../../hooks/usePermission";

type props = {
  rows: Category[];
  setOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedId: Dispatch<SetStateAction<string>>;
  setSelectedName: Dispatch<SetStateAction<string>>;
  setOpenDelete: Dispatch<SetStateAction<boolean>>;
  handleStatusUpdate: (id: string, status: boolean) => void;
  setPage: Dispatch<SetStateAction<number>>;
  page: number;
  loading: boolean;
  count: number;
};

const CategoryList = ({
  rows,
  setOpen,
  setSelectedId,
  setOpenDelete,
  setSelectedName,
  handleStatusUpdate,
  loading,
  page,
  setPage,
  count,
}: props) => {
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const {isAdd,isDelete} = usePermission({label:"Manage Categories",page_permission:"isView"})
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 2,
      minWidth: 100,
      field: "categoryName",
      headerName: "Category Name",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 180,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.createdAt).format("DD MMM YYYY")}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={!row?.isBlocked}
            onChange={() => handleStatusUpdate(row?._id, !row?.isBlocked)}
          />
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
            {isAdd &&  <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setSelectedName(row?.categoryName || "");
                  setOpen(true);
                }}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>}
            </Box>
            <Box>
             {isDelete && <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>}
            </Box>
          </div>
        );
      },
    },
  ];

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  return (
    <>
      <div className="sorting_table">
        {/* <TableComponent columns={columns} rows={rows} />
         */}

        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </div>

      {/* <AddCategory
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        handleSubmit={() => {}}
      /> */}
    </>
  );
};

export default CategoryList;
